


export default function NextIcon({width=43, height=43}) {
    return <svg height={height} width={width} viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21.5" cy="21.5" r="21" stroke="currentColor"/>
    <path d="M32.3536 22.3536C32.5488 22.1583 32.5488 21.8417 32.3536 21.6464L29.1716 18.4645C28.9763 18.2692 28.6597 18.2692 28.4645 18.4645C28.2692 18.6597 28.2692 18.9763 28.4645 19.1716L31.2929 22L28.4645 24.8284C28.2692 25.0237 28.2692 25.3403 28.4645 25.5355C28.6597 25.7308 28.9763 25.7308 29.1716 25.5355L32.3536 22.3536ZM11 22.5H32V21.5H11V22.5Z" fill="currentColor"/>
</svg>
}